import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=231a2504&scoped=true&"
import script from "./SelectableCard.vue?vue&type=script&lang=js&"
export * from "./SelectableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a2504",
  null
  
)

export default component.exports